import { Injectable } from '@angular/core';
import { cloneDeep as _cloneDeep, defaultsDeep as _defaultsDeep } from 'lodash';
import { DeviceType } from './device-type';
import { deviceTypes as deviceTypesData, deviceTypesByCodeDictionary as deviceTypesByCodeDictionaryData, deviceTypesByIdDictionary as deviceTypesByIdDictionaryData } from './device-types.data';

@Injectable({
  providedIn: 'root'
})
export class DeviceTypeService {

  private deviceTypes = _cloneDeep(deviceTypesData);
  private deviceTypesByCodeDictionary = _cloneDeep(deviceTypesByCodeDictionaryData);
  private deviceTypesByIdDictionary = _cloneDeep(deviceTypesByIdDictionaryData);

  private defaultDeviceType: DeviceType = {
    code: '',
    displayName: 'Unknown',
    id: -1,
    imageKey: 'generic-boarder-2tone',
  };

  public constructor() { }

  public getDeviceTypeByCode(code: string): DeviceType | undefined {
    return _cloneDeep(this.deviceTypesByCodeDictionary[code]);
  }

  public getDeviceTypeByCodeOrDefault(code: string, defaultOverrides?: Partial<DeviceType>): DeviceType {
    defaultOverrides = defaultOverrides ?? {};

    const partialDeviceType: Partial<DeviceType> = { code: code };

    return _cloneDeep(this.deviceTypesByCodeDictionary[code] ?? _defaultsDeep({}, defaultOverrides, partialDeviceType, this.defaultDeviceType));
  }
}
